import { render, staticRenderFns } from "./trainee-report.vue?vue&type=template&id=ed0e0f62&scoped=true"
import script from "./trainee-report.vue?vue&type=script&lang=js"
export * from "./trainee-report.vue?vue&type=script&lang=js"
import style0 from "./trainee-report.vue?vue&type=style&index=0&id=ed0e0f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0e0f62",
  null
  
)

export default component.exports